var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0013,
    cy: 9.99935,
    r: 2.73333,
    stroke: "white",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6798 8.93999C17.0712 9.4024 17.2669 9.63361 17.2669 10C17.2669 10.3664 17.0712 10.5976 16.6798 11.06C15.4376 12.5277 12.9127 15 10 15C7.08732 15 4.56244 12.5277 3.32019 11.06C2.9288 10.5976 2.7331 10.3664 2.7331 10C2.7331 9.63361 2.9288 9.4024 3.32019 8.93999C4.56244 7.47233 7.08732 5 10 5C12.9127 5 15.4376 7.47233 16.6798 8.93999Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconWhite);
export default __webpack_public_path__ + "static/media/eye-icon-white.ae9cb9b2a704cb23f13ad85c3d2cca5d.svg";
export { ForwardRef as ReactComponent };